import { configAtom } from "@/config.ts";
import type { LocationSlug } from "@/modules/location/locationQuery.ts";
import { atom } from "jotai/vanilla";

const locationsAtom = atom((get) => get(configAtom).locations);

export const locationSlugsAtom = atom<LocationSlug[]>((get) => get(locationsAtom).map((l) => l.slug));

export const canCreateResourceLocationsAtom = atom<LocationSlug[]>((get) =>
    get(locationsAtom)
        .filter((l) => !l.create_resource_disabled)
        .map((l) => l.slug),
);
